import { meetingRoomsConstants } from '../redux-constants/meetingRooms.constants'

export function meetingRoomsFetch(payload) {
    return {
        type: meetingRoomsConstants.FETCH,
        payload,
    }
}
